import { render, staticRenderFns } from "./CampaignsPerformanceFilter.vue?vue&type=template&id=42b37012"
import script from "./CampaignsPerformanceFilter.vue?vue&type=script&lang=js"
export * from "./CampaignsPerformanceFilter.vue?vue&type=script&lang=js"
import style0 from "./CampaignsPerformanceFilter.vue?vue&type=style&index=0&id=42b37012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports